//==> Program Array nested in questionSEVEN.qna
const questionONE = {
  indexNum: "one",
  question: "What is your age?",
  progress: 1,
  qna: [{
    qNum: "one",
    option: "Teen",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    response: "As a teen, now is the time to set the foundation for the rest of your life! Sugars consumed at this age can affect hormones and metabolism for years to come. Quality proteins and building a strong, lean body are the move now my teen babes."
  },{
    qNum: "two",
    option: "20",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    response: "In your 20s, it's common to gain more weight in your abdominals and hips. This is due to a lack of testosterone (compared to when you were younger) and eating too many calories for your activity needs. Now is the time to put Netflix on hold and lock in a strong, fat burning body for the decades to come."
  },{
    qNum: "three",
    option: "30",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    response: "In your 30s, your testosterone and HGH hormones will decline in the next coming. years. However, most weight gain is due to a decrease in activity. Proper nutrition and training is crucial in this stage of your life, not just to prevent weight gain, but to really shape your body."
  },{
    qNum: "four",
    option: "40",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    response: "First, peri-menopause often starts around 40, meaning 10 years of estrogen and progesterone fluctuations until menstrual periods stop. Yay, fun. Those are the sex hormones that are responsible for your mood and often weight gain. Your muscle is also starting to break down faster and you become more susceptible to gaining weight. It is vitally important to prioritize weight training and nutrition to optimize your muscle and fat burning hormones. Buckle up for menopause too, you want to keep your testosterone high through strength training to prevent burdensome side effects. Prevention is the best medicine."
  },{
    qNum: "five",
    option: "50",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    response: "As a woman over 50, you’ve been riding the hormonal roller coaster. I hope you fastened your seat belt, because three key hormonal issues — sex hormone imbalances, stress, and thyroid problems — can make the ride particularly bumpy. In your 50s, your estrogen and progesterone drop. Optimizing your hormones through proper training and nutrition will reduce your inflammation and promote anti-aging."
  },{
    qNum: "six",
    option: "60",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    response: "After menopause, estrogen and progesterone have left the building. This change can cause weight gain, brain fog, fatigue, low sex drive, and hot flashes, amoung other issues. Now’s a good time to optimize your hormones through proper training and nutrition to reduce inflammation and promote anti-aging."
  }]
};

const questionTWO = {
  indexNum: "two",
  question: "Describe your energy/stress level?",
  progress: 2,
  qna: [{
    qNum: "one",
    option: "Steady Energy / Low Stress",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/energy.png?v=1596478177",
    response: ""
  },{
    qNum: "two",
    option: "Low Energy / Low Stress",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/energy.png?v=1596478177",
    response: "Your nutrition is killing your energy levels. Limit the inflammatory foods that cause lethargy, brain fog, and acne. It affects you more than you can imagine, trust. "
  },{
    qNum: "three",
    option: "Low Energy / High Stress",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/energy.png?v=1596478177",
    response: "Your stress levels are lit. When that happens, your cortisol (stress hormone) levels rise. This can cause weight gain, especially in the abs, easy bruising, slowed digestion, and acne. Excess cortisol stimulates glucose production which is typically stored as stubborn belly fat."
  },{
    qNum: "four",
    option: "High Energy / High Stress",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/energy.png?v=1596478177",
    response: "Looks like you’re the energizer bunny. Being in a state of ‘fight or flight’ all the time wrecks havoc on your body. Your stress levels are off the chain. When that happens, your cortisol (stress hormone) levels rise. Excess cortisol stimulates glucose production which is typically stored as stubborn belly fat."
  }]
};

const questionTHREE = {
  indexNum: "three",
  question: "Do you experience the following?",
  subText: "[Select all that apply]",
  progress: 3,
  qna: [{
    qNum: "one",
    option: "Acne",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/dna.png?v=1596478177",
    response: "Food is fuel, unless you’re a Tesla, then it’s the charger. Fuel with gluten, sugar, and processed carbs and you’re bound to crash. Inflammatory and high-sugar foods can cause a leaky gut that wrecks havoc on your skin, mood, and brain clarity. Dial that diet in and you’ll see improvements across the board"
  },{
    qNum: "two",
    option: "Tiredness/Brain Fog",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/dna.png?v=1596478177",
    response: "Food is fuel, unless you’re a Tesla, then it’s the charger. Fuel with gluten, sugar, and processed carbs and you’re bound to crash. Inflammatory and high-sugar foods can cause a leaky gut that wrecks havoc on your skin, mood, and brain clarity. Dial that diet in and you’ll see improvements across the board"
  },{
    qNum: "three",
    option: "Candida/Yeast Infections",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/dna.png?v=1596478177",
    response: "Food is fuel, unless you’re a Tesla, then it’s the charger. Fuel with gluten, sugar, and processed carbs and you’re bound to crash. Inflammatory and high-sugar foods can cause a leaky gut that wrecks havoc on your skin, mood, and brain clarity. Dial that diet in and you’ll see improvements across the board"
  },{
    qNum: "four",
    option: "Irritability & Mood Swings",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/dna.png?v=1596478177",
    response: "Food is fuel, unless you’re a Tesla, then it’s the charger. Fuel with gluten, sugar, and processed carbs and you’re bound to crash. Inflammatory and high-sugar foods can cause a leaky gut that wrecks havoc on your skin, mood, and brain clarity. Dial that diet in and you’ll see improvements across the board"
  },{
    qNum: "five",
    option: "None of the Above",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/intestine.png?v=1596478177",
    response: ""
  }]
};

const questionFOUR = {
  indexNum: "four",
  question: "Describe your digestive health",
  subText: "[Bloating, Excessive Gas, Constipation, IBS, Acid Reflux]",
  progress: 4,
  qna: [{
    qNum: "one",
    option: "Good, No Issues",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/intestine.png?v=1596478177",
    response: "'Digestion is looking strong! We can still supercharge your muscle and nutrient absorption with key supplements and nutrition."
  },{
    qNum: "two",
    option: "Occasional Issues",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/intestine.png?v=1596478177",
    response: "Looks like your gut needs some TLC, just as much as Brittany Spears in 2008, aka it’s pissed off!. It’s not just the foods you eat, rather how you react to them. Optimizing your digestion is the key to leaning out, acquiring laser focus, and building lean, hard muscle."
  },{
    qNum: "three",
    option: "Frequent Issues",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/intestine.png?v=1596478177",
    response: "Looks like your gut needs some TLC, just as much as Brittany Spears in 2008, aka it’s pissed off!. It’s not just the foods you eat, rather how you react to them. Optimizing your digestion is the key to leaning out, acquiring laser focus, and building lean, hard muscle."
  }]
};

const questionFIVE = {
  indexNum: "five",
  question: "How many meals do you usually eat?",
  progress: 5,
  qna: [{
    qNum: "one",
    option: "1-2 meals a day",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/nutrition.png?v=1596478176",
    response: "Think of your metabolism like a fire. Welp, you need to add fuel to the fire. Your metabolism is in survival mode, which means it doesn’t want to burn calories or lose any weight. Upping your metabolic heat is key."
  },{
    qNum: "two",
    option: "3 meals a day",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/nutrition.png?v=1596478176",
    response: "Hell yes! Your meal frequency is on track. Let's make sure we optimize protein intake for optimal fat loss and lean muscle"
  },{
    qNum: "three",
    option: "3-4 meals a day w/ snacks",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/nutrition.png?v=1596478176",
    response: "You’re on target for meal frequency, however, snacks can disrupt your bodies ‘down time’ to digest. Spiking your insulin and blood sugar with snacks without providing a full source of protein is stalling your results."
  },{
    qNum: "four",
    option: "4 meals a day",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/nutrition.png?v=1596478176",
    response: "Hell yes! Your meal frequency is on track. Let's make sure we optimize protein intake for optimal fat loss and lean muscle"
  },{
    qNum: "five",
    option: "4 meals a day w/ snacks",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/nutrition.png?v=1596478176",
    response: "You’re on target for meal frequency, however, snacks can disrupt your bodies ‘down time’ to digest. Spiking your insulin and blood sugar with snacks without providing a full source of protein is stalling your results."
  }]
};

const questionSIX = {
  indexNum: "six",
  question: "Tell me about your current fitness.",
  subText: "[Select the best answer]",
  progress: 6,
  qna: [{
    qNum: "one",
    option: "Inactive",
    optionSubText: "",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/health.jpg?v=1599107631",
    response: "An active life is a healthy one. Start slowly with 2-3 days per week of training and lift weights to relieve stress, slow aging, and increase your metabolism. Netflix will still be there after the gym, I promise."
  },{
    qNum: "two",
    option: "Cardio and machines",
    optionSubText: "(Elliptical, cable & weight machines)",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/back.jpg?v=1599093198",
    response: "Your current training routine is not challenging enough to produce long-lasting results. You are on the treadmill of life by burning temporary calories only to gain them back from a granola bar. Instead, let’s focus on optimizing your hormones, metabolism, and muscles to help burn more calories with less effort. "

  },{
    qNum: "three",
    option: "Lifting weights",
    optionSubText: "(Rows, deadlifts, HIIT, squats, etc)",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/muscle.png?v=1596478177",
    response: "Your training seems lit. Just make sure you’re optimizing your movement patterns and progressive overload. "
   },{
    qNum: "four",
    option: "Group fitness classes",
    optionSubText: "(Zumba, Pilates, Yoga, Spin, F15, etc)",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/fire.png?v=1596478177",
    response: "Group classes might feel like a serious sesh, but I’ll let you in on a secret--you’re only burning temporary calories. Repetitive movements and a lack of progressive overload leaves hormones and metabolism unchecked, meaning you’re working harder, not smarter."
   }]
};

const questionSEVEN = {
  indexNum: "seven",
  question: "What is your ideal body type?",
  subText: "[Pick One of Four]",
  progress: 7,
  qna: [{
    qNum: "one",
    response: "Fighter",
    option: ["Rock hard build, 6-pack & vascular biceps"],
    horoscope: "The Fighter is designed to help you feel strong and look strong. This program is ideal for those wanting to build hyper-defined muscles for confidence and strength. A MoMo favorite!",
    bulletPoints: ["Rock hard upper body", "Poppin’ veins & biceps", "V-lines & defined 6-pack", "Lean muscle & athleticism"  ],
    leadPages: "SqVbSgvvwrFUCgBxTVRKZf",
    image: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/Black_Flex.jpg?v=1641718889",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    productImg: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/fighter-flat-cover_thumbnail.png?v=1634750525",
    link: "https://www.momomuscle.co/collections/all/products/the-fighter-program",
    reviews: [{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_28.png?v=1656571333`,
      txt: `I'm 40 and got those results in 5 weeks. It's different than being in the 20s. The Fighter, especially the nutriton, got me in the best shape of my life.`
      },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/Testimonials-4_2.png?v=1661408607`,
      txt: `First and only time i’ve felt good about my bod, even got the toxic masculinity gym bros from back in high school in my dms telling me i look jacked 😤`
    },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/Testimonials-18_1.png?v=1661408608`,
      txt: `This is about 9 months between photos, down 35 lbs and I feel strong as hell. The Fighter changed my life and I couldn’t have done it without you! `
    }]
  },{
    qNum: "two",
    response: "Legend",
    option: ["Maximal amount of muscle & strength"],
    horoscope: "The Legend is designed to help you unlock previously unattainable gains and bust through progress plateaus. This program is ideal for experienced lifters wanting to build muscle mass for a jaw dropping physique.",
    bulletPoints: [ "Dense bulletproof muscles", "Full body strength gains", "Impressive size and power", "Thick, turtle shell 6-pack" ],
    leadPages: "qofvBPbntvdfWw2GJq26pi",
    image: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/the-legend.png?v=1602890471",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    productImg: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/legend-flat-cover_thumbnail.png?v=1634750526",
    link: "https://www.momomuscle.co/collections/all/products/the-legend-program",
    reviews: [{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_30.png?v=1656571333`,
      txt: `I'm grateful to have found a program and community that lines up with my goals and lifestyle. I started on the Legend and then moved to the Fighter Feed on the app. For the first time in years, I am injury free and getting stronger every week.`
      },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_01.png?v=1656571333`,
      txt: `Hey! I started using the legend program around 6 months ago. Just wanted to thank you for making this program and all of your content. This is the first time I haven’t felt extremely dysphoric about my hips!`
    },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_18.png?v=1656571333`,
      txt: `The Legend Program gets you jacked!  No lie.`
    }]
  },{
    qNum: "three",
    response: "Model",
    option: ["Slender, lean & perfect posture"],
    horoscope: "The Model is designed to supercharge fat loss, improve posture, and totally shred the body. This program is ideal for those wanting to increase the impact of conditioning without putting on muscle.",
    bulletPoints: [ "Tight abs, arms and booty", "Confident, attractive posture", "Maximum fat shredding", "Lean, defined figure" ],
    leadPages: "U7p8AVTAsNKFpf9g6nieJW",
    image: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/THE_MODEL.jpg?v=1641718889",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    productImg: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/model-flat-cover_thumbnail.png?v=1634751737",
    link: "https://www.momomuscle.co/collections/all/products/model-program",
    reviews: [{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_12.png?v=1656571333`,
      txt: `I see more definition in my shoulders, back and abs. I also have a shit ton more energy. My biggest gains, though, are in my self-confidence and attitude! I wasn’t able to do this without the guidance and support from Morgan Olson and the amazing community that she have brought together! Coach, you are exactly what our community needs. Thank you so much!`
      },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_09.png?v=1656571333`,
      txt: `Just wanna say thank you for giving such helpful advice!! This is a 4 month difference and thank you for kicking my ass🥰`
    },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_10.png?v=1656571333`,
      txt: `I mean every word, your Model Program is 10xs more informative for like half the price of all the other shit I’ve tried. You should be super proud! `
    }]
  },{
    qNum: "four",
    response: "Surfer",
    option: ["Bikini booty, sculpted shoulders & tight waist"],
    horoscope: "The Surfer is designed to sculpt and tone with a focus on building a Brazilian butt, arms, and abs. This program is ideal for those wanting a bikini body with an athletic twist.",
    bulletPoints: [ "Sculpted abs, arms, & booty", "Body confidence and posture", "Fat shredding and lean muscle", "Athletic bikini body" ],
    leadPages: "igSUpLquKaPSExJnbSN9Rn",
    image: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/quiz_surfer.jpg?v=1671500177",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    productImg: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/surfer-flat-cover_thumbnail.png?v=1634750526",
    link: "https://www.momomuscle.co/collections/all/products/the-surfer-program",
    reviews: [{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_36.png?v=1656571333`,
      txt: `Aww well I’m just so happy I found your program. It’s truly inspiring to see everyone doing it and their progress 😉`
      },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_35.png?v=1656571333`,
      txt: `I’m actually feeling happiest about is that my bloating has gone down. Thanks Momo for the program and great workouts. I’ll be on the Surfer Program for life! `
    },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_29.png?v=1656571333`,
      txt: `3 months difference thanks to you ❤️ I’ve been off track a couple times but for the most part I’ve stuck to the nutrition and your workout program the surfer. Thank you so much! 😊`
    }]
  }]
};

const questionEIGHT = {
  indexNum: "eight",
  question: "What would you love to achieve?",
  subText: "[Select all the apply]",
  progress: 8,
  qna: [{
    qNum: "one",
    option: "Improve Digestion"
  },{
    qNum: "two",
    option: "Confident Posture"
  },{
    qNum: "three",
    option: "Brazilian Booty"
  },{
    qNum: "four",
    option: "Clarity & Energy"
  },{
    qNum: "five",
    option: "Tighter Waist"
  },{
    qNum: "six",
    option: "Stronger Upper Body"
  },{
    qNum: "seven",
    option: "Ripped Abs"
  },{
    qNum: "eight",
    option: "Visible Veins"
  }]
};

//========> Response Headshot & Signature
const headshot = 'https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momo_headshot_square.jpg?v=1659908400';
const signature = 'https://cdn.shopify.com/s/files/1/0017/7533/7583/files/Morgan_signature_darkgrey.png?v=1600379034';